/* eslint-disable */
/**
 * @author Leonel Martinez
 * @description `settingsService`
 * @exports settingsService
 */
import { http } from "@/utils";

export const settingsService = {
  getSkin: () => http.get('').catch(e => e.response)
};